module.exports = __webpack_public_path__ + "static/media/alphamonitor.87e890e4.png";